<template>
  <div>
    <div class="barcode-scanner-container" v-if="isMediaStreamAPISupported">
      <div class="panel settings-container">
        <div class="panel-body text-left">
          <b class="glyphicon glyphicon-cog float-right" @click="showSettings = !showSettings"></b>
          <div class="panel panel-default c4-bg" v-show="showSettings">
            <div class="panel-body">
              <b @click="showAvailableBarcodeReaders = !showAvailableBarcodeReaders">Barcode Types <sub class="glyphicon glyphicon-expand"></sub></b><br />
              <p v-show="showAvailableBarcodeReaders">
                <span class="settings-item" v-for="reader in availableBarcodeReaders">
                  <input type="checkbox" :id="'barcode-type-' + reader.value" :value="reader.value" v-model="selectedBarcodeReaders">
                  <label :for="'barcode-type-' + reader.value" style="display:inline;">{{reader.name}}</label>
                </span>
              </p>
            </div>
          </div>
          <button class="btn c1-bg" @click="clickScanButton">{{scanButtonMessage}}</button>
          <div>
            <b>Detected barcode:</b> {{detected}}
          </div>
        </div>
      </div>
      <div>
        <scandit-scanner :start-scan.sync="startScan"
                         :license-key="licenseKey"
                         :configuration-options="configurationOptions"
                         :scan-settings="scanSettings"
                         @get-detected-code="getDetectedCode($event)"
                         v-show="startScan"></scandit-scanner>
      </div>
    </div>
    <div v-else>
      <div class="panel">
        <div class="panel-body">
          {{mediaNotSupportedMessage}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as ScanditSDK from "scandit-sdk";
  import ScanditScanner from "./ScanditBarcodeScanner";

  export default {
    name: "ScanditBarcodeReader",
    components: {
      ScanditScanner
    },
    props: {
      startScan: Boolean,
      licenseKey: String,
      configurationOptions: Object,
    },
    data() {
      return {
        detected: '',
        scanButtonMessage: '',
        isMediaStreamAPISupported: false,
        showSettings: false,
        mediaNotSupportedMessage: 'Webcam is not supported!',
        selectedBarcodeReaders: ["ean8", "ean13", "upca", "upce", "code128", "code39", "code93", "itf"],
        showAvailableBarcodeReaders: false,
        scanSettings: {
          enabledSymbologies: ["ean8", "ean13", "upca", "upce", "code128", "code39", "code93", "itf"]
        }
      };
    },
    computed: {
      availableBarcodeReaders: function () {
        let arr = [];
        for (const key in ScanditSDK.Barcode.Symbology) {
          if (typeof ScanditSDK.Barcode.Symbology[key] !== 'string') continue;
          arr.push({ name: key, value: ScanditSDK.Barcode.Symbology[key] });
        }
        //console.log(arr);
        return arr;
      }
    },
    mounted: function () {
      this.scanButtonMessage = !this.startScan ? 'Start Scan' : 'Stop Scan';
      const lastSelectedBarcodeReaders = JSON.parse(this.$cookies.get('lastSelectedBarcodeReaders'));
      //console.log(lastSelectedBarcodeReaders);
      //console.log(this.selectedBarcodeReaders);

      if (lastSelectedBarcodeReaders && lastSelectedBarcodeReaders.length > 0)
        this.selectedBarcodeReaders = lastSelectedBarcodeReaders.filter(v => this.availableBarcodeReaders.some(x => x.value === v));

      this.scanSettings.enabledSymbologies = this.selectedBarcodeReaders;

      navigator.mediaDevices.getUserMedia({ video: true })
        .then(() => {
          navigator.mediaDevices.enumerateDevices()
            .then((devices) => {
              devices.forEach((device) => {
                //alert(device.kind + "  " + device.label);
                if (device.kind == "videoinput") {  // && device.label.toLowerCase().match(/back/) !== null
                  this.isMediaStreamAPISupported = true;
                }
              });
            })
            .catch(function (err) {
              //alert(err);
              return console.log(err);
            });
        })
        .catch(function (err) {
          //alert(err);
          return console.log(err);
        });
    },
    watch: {
      startScan: function (newValue, oldValue) {
        //console.log("ScanditBarcodeReader - startScan changed: " + newValue);
        this.scanButtonMessage = !newValue ? 'Start Scan' : 'Stop Scan';
        this.$emit('update:startScan', newValue);
      },
      selectedBarcodeReaders: function (newValue, oldValue) {
        this.$cookies.set('lastSelectedBarcodeReaders', JSON.stringify(newValue));
        this.scanSettings = { enabledSymbologies: this.selectedBarcodeReaders };
        //this.scanSettings.enabledSymbologies = this.selectedBarcodeReaders;
      },
    },
    methods: {
      clickScanButton() {
        this.startScan = !this.startScan;

        if (this.startScan) {
          this.showSettings = false;
        }
      },
      getDetectedCode(detectedCode) {
        this.detected = detectedCode;
        this.$emit('barcode-detected', detectedCode);
      }
    },
  };
</script>

<style scoped>
  .barcode-scanner-container {
    position: relative;
    height: 90vh;
  }

  .settings-container {
    /*position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2040;
    background-color: rgba(0,0,0,0);*/
  }

    .settings-container .settings-item {
      display: inline-block;
      padding-right: 10px;
    }

      .settings-container .settings-item label {
        display: inline;
      }
</style>



// WEBPACK FOOTER //
// EcomCore/Components/InputDevices/ScanditBarcodeReader.vue